import { render } from "./yos-button.vue?vue&type=template&id=61dbd186"
import script from "./yos-button.vue?vue&type=script&lang=js"
export * from "./yos-button.vue?vue&type=script&lang=js"

import "./yos-button.vue?vue&type=style&index=0&id=61dbd186&lang=postcss"
script.render = render

export default script